import { ChangeDirectDebitAmount } from '@ovotech/energy-cx';
import { Stack } from '@ovotech/nebula';
import React from 'react';
import { OneClickPaymentReductionMain } from '../components/OneClickPaymentReduction/OneClickPaymentReductionMain';
import { StruggleToPay } from './StruggleToPay';
import { PageWithNavigationAndSectionPadding } from '@/src/components';
import { ONE_CLICK_PAYMENT_REDUCTION } from '@/src/constants/feature-flags';
import { OptimizelyFeature } from '@/src/utils/optimizely';

const ChangeDirectDebitAmountRoute = () => {
  return (
    <PageWithNavigationAndSectionPadding title="Change direct debit amount">
      <Stack spaceBetween={[4, 8]}>
        <ChangeDirectDebitAmount />
        <OptimizelyFeature feature={ONE_CLICK_PAYMENT_REDUCTION}>
          {isEnabled =>
            isEnabled ? <OneClickPaymentReductionMain /> : <StruggleToPay />
          }
        </OptimizelyFeature>
      </Stack>
    </PageWithNavigationAndSectionPadding>
  );
};

export default ChangeDirectDebitAmountRoute;
